import { Button } from '@astrid/components'
import { ReactComponent as WarningIcon } from 'resources/graphics/icons/warning.svg'

import styles from './ConfirmDelete.module.scss'

interface ConfirmDeleteProps {
  onCancel: () => void
  onDelete: () => void
}

export const ConfirmDelete = ({ onCancel, onDelete }: ConfirmDeleteProps) => {
  return (
    <div className={styles.container}>
      <WarningIcon className={styles.icon} />
      <span className={styles.text}>Are you sure you want to delete this word group?</span>
      <div className={styles.footer}>
        <Button type="button" variant="filled" color="secondary" onClick={onDelete}>
          Delete
        </Button>
        <Button type="button" variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )
}
